











































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component({
    components: {
        DatePicker,
    },
})
export default class ExpirationEmail extends Mixins(LocalizationMethods) {
    public expirationDate: string = '';
    constructor() {
        super();
    }

    public sendExpirationEmail() {
        if (this.expirationDate === '') {
            return false;
        }

        this.$store.dispatch(Actions.SEND_EXPIRATION_EMAIL, {expirationDate: this.expirationDate});
    }

    public cancel() {
       this.$store.commit(Mutations.SET_EXPIRATION_EMAIL_VISIBILITY, false);
    }
}
